var generateStyle = function generateStyle(componentTheme) {
  return {
    groupAggregationContainer: {
      display: 'flex',
      gap: componentTheme.aggregateSpacing
    }
  };
};
export default generateStyle;